/**
 * 페이월 모달 상태 훅 — 글로벌 싱글톤 (Issue #446 PR4)
 *
 * 모듈 스코프 상태 + useSyncExternalStore로 모든 호출처가 동일한 페이월
 * open/close 상태를 공유합니다. PaywallModal은 App.tsx에서 단 1회만 mount
 * 하면 충분합니다 (다중 인스턴스 금지).
 *
 * API는 기존과 동일:
 *   const { isPaywallOpen, openPaywall, closePaywall } = usePaywall();
 */

import { useSyncExternalStore } from "react";

let isOpen = false;
const listeners = new Set<() => void>();

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function getSnapshot(): boolean {
  return isOpen;
}

function notify(): void {
  listeners.forEach((listener) => listener());
}

export function openPaywall(): void {
  if (isOpen) return;
  isOpen = true;
  notify();
}

export function closePaywall(): void {
  if (!isOpen) return;
  isOpen = false;
  notify();
}

export function usePaywall() {
  const isPaywallOpen = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  return {
    isPaywallOpen,
    openPaywall,
    closePaywall,
  };
}
